import { PageRef } from "../ars_ldm";
import { isObjectRecord } from "./isObjectRecord";

/**
 * Type guard to check if a value is a PageRef.
 *
 * @param obj - The value to check.
 * @returns True if the value is a PageRef.
 */
export const isPageRef = (obj: unknown): obj is PageRef => {
  if (!isObjectRecord(obj)) return false;

  if (typeof obj.refType !== "string") return false;
  if (obj.label !== undefined && typeof obj.label !== "string") return false;

  if (obj.pageNames !== undefined) {
    if (!Array.isArray(obj.pageNames)) return false;
    if (obj.pageNames.some((name) => typeof name !== "string")) return false;
  }

  if (obj.pageNumbers !== undefined) {
    if (!Array.isArray(obj.pageNumbers)) return false;
    if (obj.pageNumbers.some((pageNumber) => typeof pageNumber !== "number")) return false;
  }

  if (obj.firstPage !== undefined && typeof obj.firstPage !== "number") return false;
  if (obj.lastPage !== undefined && typeof obj.lastPage !== "number") return false;

  return true;
};
